@if ($page(); as vm) { @if (vm.status !== 'idle') {
<div class="flex flex-col gap-6 min-h-screen bg-neutral-50">
  <!-- @if (vm.pageResponse?.pageAsset?.layout?.header) { @if (vm.pageResponse?.content?.navigation?.children) {
  <custom-dot-cms-uve-header-navigation [items]="vm.pageResponse?.content?.navigation?.children || []" />
  } } -->
  <main class="container m-auto">
    @if (vm.status === 'loading') {
    <!-- <app-loading /> -->
    } @else if (vm.status === 'error' && vm.error) {
    <!-- <app-error [$error]="vm.error" /> -->
    } @else if (!pageLoading() && vm.status === 'success' && vm.pageResponse ) {
    <dotcms-layout-body dotCmsColumnClassCleanup [page]="vm.pageResponse.pageAsset" [components]="components" />
    } @else {
    <!-- Add a fallback for unexpected states -->
    <ish-loading /> }
  </main>
</div>
} }@else{
<ish-loading />
}
